import { Component, Input } from '@angular/core';
import {CurrencyPipe} from "@cybfed/shared/pipes/currency.pipe";
import {TranslateModule} from "@ngx-translate/core";
@Component({
    selector: 'white-label-sticker-ad-render',
    templateUrl: './sticker-ad-render.component.html',
    standalone: true,
    imports: [
        CurrencyPipe,
        TranslateModule
    ]
})
export class StickerAdRenderComponent {
    @Input() item!: any;
}
